import CommonModal from '../common/modal/CommonModal'

interface IChatEditTitleModalProps {
  chatTitle: string
  handleClose: () => void
  handleSaveTitle: () => void
  newTitle: string
  setNewTitle: (newTitle: string) => void
}
const ChatEditTitleModal = ({
  chatTitle,
  handleClose,
  handleSaveTitle,
  newTitle,
  setNewTitle
}: IChatEditTitleModalProps) => {
  return (
    <CommonModal
      onClose={handleClose}
      title='제목 편집'
      topButtonText='저장'
      bottomButtonText='취소'
      topButtonOnClick={handleSaveTitle}
      bottomButtonOnClick={handleClose}
      isTopButtonDisabled={!newTitle.trim().length || newTitle.trim() === chatTitle}
      modalContent={
        <div className='text-left mb-4'>
          <label htmlFor='title-input' className='text-sm font-medium text-amber-900 block mb-2'>
            새 이름
          </label>
          <input
            id='title-input'
            type='text'
            value={newTitle}
            onChange={e => setNewTitle(e.target.value)}
            className='w-full px-4 py-3 border-2 border-amber-200 rounded-lg text-sm focus:outline-none focus:border-amber-500 transition-colors bg-amber-50 text-amber-900'
            placeholder='대화 제목을 입력하세요'
            autoFocus
            maxLength={50}
          />
        </div>
      }
    />
  )
}

export default ChatEditTitleModal
